<template>
  <div class="packages_container w-row">
    <div class="column-25 w-col w-col-6" v-for="item in data.CT_PACKAGES" :key="item.PACKAGE_ID">
      <div class="package_bloc">
        <div class="package_description">
          <h1 class="heading-7">{{ item.PACKAGE_DESC }}</h1>
          <p class="bold_label">{{ $t(packageTexts[item.PACKAGE_ID]) }}</p>
        </div>
        <div class="package_cta_area">
          <button type="button" class="button_circle_medium w-button" @click="selectPackage(item)">{{$t('SELECT')}} {{ $u.formatMoney(item.AMOUNT) }}</button>
        </div>
        <div class="packaging_coverings_area w-row">
          <div class="column-24 w-col w-col-6">
            <h1 class="heading-8">{{$t('COVERS')}}</h1>
          </div>
          <div class="column-23 w-col w-col-6">
            <button type="button"  class="button_extra_small w-button" @click="goAnalytic">{{$t('ANALYTIC')}}</button>
          </div>
        </div>
        <template v-for="cover in data.CT_COVERS">
          <div class="package_list_item" :key="cover.COVER_ID" v-if="cover.PACKAGE_ID === item.PACKAGE_ID && cover.ZZMANDATORY_IND">
            <h1 class="heading-9">{{ cover.COVER_DESC }}</h1>
            <div class="package_feature_bullet"></div>
          </div>
        </template>
         <div class="package_download_bar w-row">
              <div class="w-col w-col-6">
                <a href="javascript:;" class="package_download_link w-inline-block"><img src="@/assets/images/Shape.svg" loading="lazy" width="32" alt="" class="image-9">
                  <h1 class="package_download_header" v-html="$t('INSURANCE_POLICY_DETAILS')"></h1>
                </a>
              </div>
              <div class="w-col w-col-6">
                <a href="javascript:;" class="package_download_link w-inline-block"><img src="@/assets/images/Shape.svg" loading="lazy" width="32" alt="" class="image-9">
                  <h1 class="package_download_header" v-html="$t('INSURANCE_POLICY_TEXT')"></h1>
                </a>
              </div>
            </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      packageTexts: {
        1: 'PAGKAGE_WEB_TEXT',
        2: 'PAGKAGE_WEB_PLUS_TEXT',
        3: 'PAGKAGE_COMPREHENSIVE_WEB_TEXT',
        4: 'PAGKAGE_COMPREHENSIVE_SUPERIOR_WEB_TEXT',
      }
    };
  },
  methods: {
    selectPackage(item) {
      this.$emit('select-package', item);
    },
    goAnalytic() {
      this.$emit('next');
    }
  },
};
</script>

<style lang="scss" scoped>
.packages_container {
  display: flex;
  flex-wrap: wrap;
  & .column-25.w-col.w-col-6 {
    flex-basis: 50%;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    height: auto;
    margin-bottom: 20px;
    & .package_bloc {
      display: flex;
    }
    & .package_download_bar{
      display: flex;
      flex-grow: 1;
      align-items: flex-end;
    }
  }
}
</style>
